import React from 'react';

import styles from './RetestChart.module.css';

// Decorative illustration, not a plot: geometry is taken verbatim from the
// Figma frame (375x511) rather than derived from the kit's data.
const BASELINE_Y = 436;

const POINTS = [
  { cx: 74.383, cy: 267.41, lineTo: 77, color: '#009B87' },
  { cx: 191.383, cy: 52.41, lineTo: 191.565, color: '#FF9898' },
  { cx: 290.383, cy: 187.41, lineTo: 290.565, color: '#EDA732' },
];

const MOUNTAIN_PATH =
  'M76.5176 265H-19.8372L-28 433.515H390.07L386.179 222.5L291 186.829L190.459 46L76.5176 265Z';

export const RetestChart: React.FC = () => (
  <svg
    className={styles.chart}
    viewBox='0 0 375 511'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    focusable='false'
  >
    <defs>
      <linearGradient
        id='retestChartFade'
        x1='93.4591'
        y1='312.5'
        x2='93.4591'
        y2='434'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#EAEBE7' />
        <stop offset='1' stopColor='#EAEBE7' stopOpacity='0' />
      </linearGradient>
    </defs>

    <path
      className={styles.mountain}
      d={MOUNTAIN_PATH}
      fill='url(#retestChartFade)'
    />

    {POINTS.map((point, index) => (
      <g
        key={point.color}
        className={styles.point}
        style={{ '--point-index': index } as React.CSSProperties}
      >
        <path
          className={styles.line}
          d={`M${point.cx} ${point.cy}L${point.lineTo} ${BASELINE_Y}`}
          stroke={point.color}
          strokeWidth='3.13014'
          strokeDasharray='6.26 6.26'
        />
        <circle
          className={styles.marker}
          cx={point.cx}
          cy={point.cy}
          r='6.38'
          fill='white'
          stroke={point.color}
          strokeWidth='3.98546'
        />
      </g>
    ))}
  </svg>
);

export default RetestChart;
